import request from "../utils/request";

/**
 * @param {{
 *  token?: string
 *  order_no?: string
 *  user_id?: string
 * } & Record<string, any>}
 * 支付中转接口，验证成功会返回支付页链接
 */
export function orderPay({ token, order_no, user_id, ...rest }) {
  return request({
    method: "post",
    url: "/biz/order/to_pay",
    data: token
      ? { token, ...rest }
      : {
          order_no,
          user_id,
          ...rest,
        },
  });
}

export function getPayMethod() {
  return request({
    url: "/biz/payment-methods",
  });
}

// 获取对公转账信息
export function getPublicTransferAccount(order_no) {
  return request({
    url: "/biz/charges/bank-account",
    method: "post",
    data: {
      order_no,
    },
  });
}

/**获取当前支付二维码是否被扫描
 * @param {string} code
 * @returns {Promise<{
 *  scanned: boolean
 * }>}
 */
export function getOrderCodeIsScaned(code) {
  return request({
    url: `/biz/order-code/${code}/scanned`,
    ignoreMessage: true,
    // 不解析url
    noParse: true,
  });
}

export function getOrderByCode(code) {
  return request({
    url: `/biz/order-code/${code}`,
    ignoreMessage: true,
    // 不解析url
    noParse: true,
  });
}

export function getOrderToken(data) {
  return request({
    method: "post",
    url: "/biz/order/create_token",
    data: data,
  });
}

export function getOrder(order_no) {
  return request({
    url: `/biz/orders/${order_no}`,
  });
}

/**
 * 订单折算金额计算, 不传优惠券信息会自动算上用户可用的优惠券
 * https://yapi.gaoding.com/project/1717/interface/api/130716
 * @param {IPayParams} data
 * @returns {Promise<IOrderCalc>}
 */
export function orderCalculate(data) {
  return request({
    method: "post",
    url: "/biz/order/calculate",
    data: data,
    ignoreMessage: true,
  });
}

export function getOrderSubscriptionTicket(data) {
  return request({
    method: "post",
    url: "/biz/order/subscription-ticket",
    data,
  });
}

export function getSubscriptionByCode(order_code) {
  return request({
    url: `/biz/order/subscription-order-code/${order_code}`,
  });
}

/**
 *
 * @param {*} query
 * @returns {Promise<{list: ISubscriptionItem[]}>}
 */
export function getSubscriptionList(query) {
  return request({
    url: "/biz/order/subscriptions",
    query,
  });
}

export function cancelSubscription(id, reason) {
  return request({
    url: `/biz/order/subscriptions/${id}/cancel`,
    method: "post",
    data: { reason },
    ignoreMessage: true,
    ignoreError: true,
  });
}
